<template>
  <div class="table-responsive">
    <table class="table table-sm table-nowrap card-table">
      <slot></slot>
    </table>
  </div>
</template>
